$('.js-toggle-social').on('click', socialToggle);

$(document).on('click', function (event) {
	if (!$(event.target).closest('.social').length) {
		socialClose($('.js-toggle-social'));
	}
});

function socialToggle() {
	event.preventDefault();
	var $this = $(this);
	if ($this.hasClass('is-expand')) {
		socialClose($this);
	} else {
		socialOpen($(this));
	}
}

function socialClose(object) {
	$(object)
		.removeClass('is-expand')
		.siblings('.js-social-list')
		.velocity('transition.slideRightOut', 200);
}

function socialOpen(object) {
	$(object)
		.addClass('is-expand')
		.siblings('.js-social-list')
		.velocity('transition.slideRightIn', 200);
}



/** WEBPACK FOOTER **
 ** ./frontend/components/social-services/compact/compact.js
 **/